<script setup lang="ts">
import data from '@/common/data/data/data'; // :shrug:
import StandardPage from '@/content-types/standard-page/StandardPage.vue';
import PageContent from '@/components/page-content/PageContent.vue';
import { useSeoMeta } from '#app';

useSeoMeta({
  title: 'Data | Open Methane',
  ogTitle: 'Data | Open Methane',
  description: 'Publicly available data and data sources used in the Open Methane project.',
  ogDescription: 'Publicly available data  and data sources used in the Open Methane project.',
});
</script>

<template>
  <StandardPage title="Data">
    <PageContent :page-data="data" />
  </StandardPage>
</template>
